var React = require('react');

function Report15 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13 2V11L10.2419 11.0005C10.7207 10.2854 11 9.4253 11 8.5C11 6.18375 9.25002 4.27623 7.00009 4.02747L7 2H13ZM6.5 5C8.433 5 10 6.567 10 8.5C10 10.433 8.433 12 6.5 12C5.89686 12 5.32935 11.8474 4.83395 11.5788L2.413 14L1 12.586L3.4212 10.166C3.15256 9.67065 3 9.10314 3 8.5C3 6.567 4.567 5 6.5 5ZM5 8.5C5 7.67157 5.67157 7 6.5 7C7.32843 7 8 7.67157 8 8.5C8 9.32843 7.32843 10 6.5 10C5.67157 10 5 9.32843 5 8.5Z","fill":"currentColor"}));
}

Report15.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none"};

module.exports = Report15;

Report15.default = Report15;
